import { Icon, IconButton } from '@zillow/constellation-10';
import IconButtonTooltip from '../../IconButtonTooltip';
import { IconRestoreMailOutline, IconUserOutline } from '@zillow/constellation-icons';
import type { Breakpoint } from '..';

const ICON_VARIANTS = {
  moveToInbox: <IconRestoreMailOutline />,
  unarchive: <IconRestoreMailOutline />,
  viewRenterProfile: <IconUserOutline />,
} as const;

type ConversationActionIconButtonProps = {
  breakpoint?: Breakpoint;
  content: string;
  isDisabled: boolean;
  onClick: () => void;
  variant: keyof typeof ICON_VARIANTS;
};

export default function ConversationActionIconButton({
  breakpoint = 'xl',
  content,
  isDisabled,
  onClick,
  variant,
}: ConversationActionIconButtonProps) {
  return (
    <IconButtonTooltip
      content={content}
      trigger={
        <IconButton
          disabled={isDisabled}
          emphasis="bare"
          onClick={onClick}
          shape="square"
          size="md"
          title={content}
          css={{
            ...(breakpoint === 'xl' && {
              xlDown: { color: '-icon.button.bare.brand.icon.default' },
              xl: { color: 'neutral' },
            }),
            ...(breakpoint === 'xxl' && {
              xxlDown: { color: '-icon.button.bare.brand.icon.default' },
              xxl: { color: 'neutral' },
            }),
          }}
        >
          <Icon>{ICON_VARIANTS[variant]}</Icon>
        </IconButton>
      }
    />
  );
}
